import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import { MenuIcon, XIcon, GlobeIcon } from 'lucide-react';
const Navbar = ({
  language,
  toggleLanguage
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent scrolling when menu is open
    if (!isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };
  const translations = {
    en: {
      home: 'Home',
      about: 'About',
      education: 'Education',
      experience: 'Experience',
      skills: 'Skills',
      organizations: 'Organizations',
      press: 'Press',
      leadership: 'Leadership',
      contact: 'Contact',
      currentLanguage: 'Current Language',
      english: 'English',
      vietnamese: 'Vietnamese',
      connectOnLinkedin: 'Connect on LinkedIn'
    },
    vi: {
      home: 'Trang chủ',
      about: 'Giới thiệu',
      education: 'Học vấn',
      experience: 'Kinh nghiệm',
      skills: 'Kỹ năng',
      organizations: 'Tổ chức',
      press: 'Báo chí',
      leadership: 'Lãnh đạo',
      contact: 'Liên hệ',
      currentLanguage: 'Ngôn Ngữ Hiện Tại',
      english: 'Tiếng Anh',
      vietnamese: 'Tiếng Việt',
      connectOnLinkedin: 'Kết nối trên LinkedIn'
    }
  };
  const t = translations[language];
  const navLinks = [{
    name: t.home,
    to: 'hero'
  }, {
    name: t.about,
    to: 'about'
  }, {
    name: t.education,
    to: 'education'
  }, {
    name: t.experience,
    to: 'experience'
  }, {
    name: t.skills,
    to: 'skills'
  }, {
    name: t.organizations,
    to: 'organizations'
  }, {
    name: t.press,
    to: 'press'
  }, {
    name: t.leadership,
    to: 'leadership'
  }, {
    name: t.contact,
    to: 'contact'
  }];
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-secondary/90 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-360">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-361">
        {/* Logo */}
        <a href="https://www.linkedin.com/in/realtrungnguyen" target="_blank" rel="noopener noreferrer" className="relative group z-20" data-id="element-362">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full overflow-hidden gradient-border transition-all duration-300 group-hover:scale-110" data-id="element-363">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oz2JDEbs664H64BHe3SMGd/Trung_Nguyen_Design.png" alt="Trung Nguyen" className="w-full h-full object-cover" style={{
            objectPosition: 'center 30%'
          }} data-id="element-364" />
          </div>
          <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-secondary text-primary text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap" data-id="element-365">
            {t.connectOnLinkedin}
          </span>
        </a>
        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-6 items-center" data-id="element-366">
          {navLinks.map((link, index) => <Link key={link.name} to={link.to} spy={true} smooth={true} offset={-70} duration={800} className="text-primary hover:text-accent-cyan animated-underline cursor-pointer transition-colors" style={{
          transitionDelay: `${index * 50}ms`
        }} data-id="element-367">
              {link.name}
            </Link>)}
          {/* Language toggle for desktop */}
          <button onClick={toggleLanguage} className="flex items-center gap-1 text-primary hover:text-accent-cyan transition-colors ml-4" aria-label="Toggle language" data-id="element-368">
            <GlobeIcon size={18} data-id="element-369" />
            <span className="text-sm" data-id="element-370">{language === 'en' ? 'EN' : 'VI'}</span>
          </button>
        </div>
        {/* Mobile Menu Button and Language Toggle */}
        <div className="md:hidden flex items-center z-20" data-id="element-371">
          {/* Mobile navigation right side - contains language toggle and menu button */}
          <div className="flex items-center space-x-4" data-id="element-372">
            {/* Language toggle for mobile - now positioned in the middle */}
            <button onClick={toggleLanguage} className="flex items-center justify-center text-primary p-2" aria-label="Toggle language" data-id="element-373">
              <GlobeIcon size={20} className="text-primary hover:text-accent-cyan" data-id="element-374" />
            </button>
            {/* Hamburger menu button */}
            <button onClick={toggleMenu} className="text-primary focus:outline-none transition-transform duration-300 hover:scale-110 p-2" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-375">
              {isMenuOpen ? <XIcon size={24} className="animate-pulse" data-id="element-376" /> : <MenuIcon size={24} data-id="element-377" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu - Full Screen Overlay */}
      <div className={`md:hidden fixed inset-0 bg-background z-10 flex flex-col justify-center items-center transition-all duration-500 ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} data-id="element-378">
        <div className="container px-4 py-8 flex flex-col space-y-4" data-id="element-379">
          {navLinks.map((link, index) => <Link key={link.name} to={link.to} spy={true} smooth={true} offset={-70} duration={800} className="text-primary hover:text-accent-cyan text-xl font-display text-center py-3 animated-underline cursor-pointer transition-all duration-300" style={{
          transform: isMenuOpen ? 'translateY(0)' : 'translateY(20px)',
          opacity: isMenuOpen ? 1 : 0,
          transitionDelay: `${index * 50}ms`
        }} onClick={() => {
          setIsMenuOpen(false);
          document.body.style.overflow = 'auto';
        }} data-id="element-380">
              {link.name}
            </Link>)}
          {/* Language indicator in mobile menu */}
          <div className="text-center mt-6 pt-6 border-t border-accent-cyan/20" data-id="element-381">
            <p className="text-muted text-sm mb-2" data-id="element-382">{t.currentLanguage}</p>
            <div className="inline-flex items-center gap-2 bg-secondary/70 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-383">
              <GlobeIcon size={16} className="text-accent-cyan" data-id="element-384" />
              <span data-id="element-385">{language === 'en' ? t.english : t.vietnamese}</span>
            </div>
          </div>
        </div>
      </div>
    </nav>;
};
export default Navbar;